function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.623,17.609a17.33,17.33,0,0,1-1.557,2.91C18.053,22.06,16.624,23.984,14.859,24c-1.571.014-1.977-1.025-4.111-1.007S8.172,24.016,6.6,24c-1.767-.016-3.118-1.749-4.131-3.288C-.365,16.4-.665,11.34,1.086,8.649A6.27,6.27,0,0,1,6.124,5.621c1.875,0,3.053,1.029,4.6,1.029,1.5,0,2.419-1.031,4.588-1.031a6.124,6.124,0,0,1,4.61,2.433A5.278,5.278,0,0,0,20.623,17.609ZM13.667,3.9A5.257,5.257,0,0,0,14.837,0a5.692,5.692,0,0,0-3.669,1.973,4.889,4.889,0,0,0-1.2,3.8A4.784,4.784,0,0,0,13.667,3.9Z"
});

var SvgApple = function SvgApple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.623,
    height: 24,
    viewBox: "0 0 20.623 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apple.2693524a.svg";
export { ForwardRef as ReactComponent };